import * as styles from './styles'

export interface Props {
  displayName: string
  usernames: string[]
  emoji: string
}

export const ReactionUsers: React.FC<Props> = ({
  displayName,
  usernames,
  emoji,
}) => {
  const filteredUsernames = usernames.filter((user) => user !== null)

  return (
    <div css={styles.header}>
      <span aria-labelledby="emoji-name" css={styles.highlightedEmoji}>
        {emoji}
      </span>
      <span id="emoji-name">{displayName}</span>
      <div>{filteredUsernames?.join(', ')}</div>
    </div>
  )
}
